import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { SlArrowDown } from "react-icons/sl";
import { BiEnvelope } from "react-icons/bi";
import { HiDotsVertical } from "react-icons/hi";
import { setProfileBoxAction } from "../../redux/auth/auth-slice";
import FilterForm from "./FilterForm";
import {
  setSections,
  setPageNext,
  setPagePrev,
  setFilteredBookings,
  setFilteredBookingsNumber,
  setIsSearch,
  clearFilterBooking,
  setFilterForm,
} from "../../redux/booking/booking-slice";
import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
} from "@fortawesome/fontawesome-free-solid";
import { useLocation } from "react-router-dom";

const Navbar = () => {
  const dispatch = useDispatch();
  const {
    pageCount,
    totalBookingCount,
    upcomingBookingLength,
    jobsForTodayLength,
    jobsForTomorrowLength,
    filterForm,
  } = useSelector((state) => state.booking);
  const { user, token, profileBoxAction } = useSelector((state) => state.auth);
  const { filteredBookings, isSearch } = useSelector((state) => state.booking);
  const navigate = useNavigate();
  const [openlogoutModal, setopenlogoutModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [tabs, settabs] = useState({
    tab1: true,
    tab2: false,
    tab3: false,
    tab4: false,
  });
  const [searchItem, setsearchItem] = useState("");
  const { pathname } = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchItem?.length > 2) {
        dispatch({
          type: "FILTER_AFFILIATE",
          payload: {
            token: token,
            affiliateId: user?._id,
            searchItem: searchItem,
          },
        });
      } else {
        dispatch(
          setFilteredBookings({
            filteredBookings: [],
          })
        );
        dispatch(
          setFilteredBookingsNumber({
            filteredBookingsLength: 0,
          })
        );
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [searchItem]);

  return (
    <div className="relative w-screen bg-black pt-4 z-50">
      {/* flex justify-between items-start */}
      <div className="grid grid-cols-12 px-3 sm:px-10 md:px-10 xl:px-16 2xl:px-32 relative">
        {/* Logo and Name */}
        <Link to="/" className="col-span-2 h-fit">
          <div className="flex items-center space-x-3">
            <img
              src={user?.logo && user?.logo?.secure_url}
              alt="Track Limo Logo"
              className="h-10 w-10"
            />

            <div className="text-[#f8f8f8] font-extrabold text-lg tracking-widest">
              {user?.affiliateName && user?.affiliateName.toUpperCase()}
            </div>
          </div>
        </Link>
        <div className="col-span-1"> </div>
        {/*  Above column is added for styling purposes, that's all */}

        {/* navbar menus */}

        {/* MOBILE VIEW */}
        {/* {token && (
          <>
            <div className="md:hidden absolute right-0.5 top-12 sm:top-20 mx-2 sm:mx-7 py-2">
              <ul className=" text-[#f5f5f5] font-medium text-sm">
                <NavLink
                  to="/ordermanage"
                  className={({ isActive }) =>
                    isActive
                      ? "text-base px-2 xs:px-5 py-1.5 "
                      : "text-base px-2 xs:px-5 py-1.5 text-slate-400"
                  }
                >
                  Order Management
                </NavLink>
                <NavLink
                  to="/driver"
                  className={({ isActive }) =>
                    isActive
                      ? "text-base px-5 py-1.5 "
                      : "text-base px-5 py-1.5 text-slate-400"
                  }
                >
                  Driver Management
                </NavLink>
              </ul>
            </div>
          </>
        )} */}

        {/* MD SCREEN VIEW */}
        {/* {token && (
          <div className="hidden absolute right-24 top-14 sm:top-14 mx-3 sm:mx-7 py-2">
            <ul className="flex space-x-10 justify-between text-[#f5f5f5] font-medium text-sm">
              <NavLink
                to="/ordermanage"
                className={({ isActive }) =>
                  isActive
                    ? "bg-[#144EE3] rounded-full border border-[#144EE3] text-base px-5 py-1.5 shadow-lg shadow-blue-700"
                    : "bg-slate-700/30 border border-slate-700/70 rounded-full text-base px-5 py-1.5 text-slate-400"
                }
              >
                Order Management
              </NavLink>
              <NavLink
                to="/driver"
                className={({ isActive }) =>
                  isActive
                    ? "bg-blue-600 rounded-full border border-blue-600 text-base px-5 py-1.5 shadow-lg shadow-blue-700"
                    : "bg-[#181E29] border border-[#353C4A] rounded-full text-base px-5 py-1.5 text-slate-400"
                }
              >
                Driver Management
              </NavLink>
            </ul>
          </div>
        )} */}

        {/* DESKTOP VIEW */}
        {token && (
          <div className="col-span-6 hidden md:block ">
            <ul className="justify-center flex space-x-8 text-[#f5f5f5] font-medium text-sm">
              <NavLink
                onClick={() => dispatch(clearFilterBooking())}
                to="/ordermanage"
                className={({ isActive }) =>
                  isActive
                    ? "bg-blue-600 rounded-full border border-blue-600 text-base px-5 py-1.5 shadow-lg shadow-blue-700"
                    : "bg-[#181E29] border border-[#353C4A] rounded-full text-base px-5 py-1.5 text-slate-400"
                }
              >
                Order Management
              </NavLink>
              <NavLink
                onClick={() => dispatch(clearFilterBooking())}
                to="/driver"
                className={({ isActive }) =>
                  isActive
                    ? "bg-blue-600 rounded-full border border-blue-600 text-base px-5 py-1.5 shadow-lg shadow-blue-700"
                    : "bg-[#181E29] border border-[#353C4A] rounded-full text-base px-5 py-1.5 text-slate-400"
                }
              >
                Driver Management
              </NavLink>
            </ul>
            {pathname === "/ordermanage" && (
              <div className="mt-6 w-full bg-[#181E29] flex items-center h-[38px] rounded-full border border-[#353C4A] shadow-[0px_4px_10px_0px_rgba(0,0,0,0.10)">
                <label htmlFor="search" className="mx-5 my-3 cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1_376)">
                      <path
                        d="M6.1653 0C2.76585 0 0 2.76585 0 6.1653C0 9.56495 2.76585 12.3306 6.1653 12.3306C9.56495 12.3306 12.3306 9.56495 12.3306 6.1653C12.3306 2.76585 9.56495 0 6.1653 0ZM6.1653 11.1924C3.39339 11.1924 1.13821 8.93725 1.13821 6.16533C1.13821 3.39341 3.39339 1.13821 6.1653 1.13821C8.93722 1.13821 11.1924 3.39339 11.1924 6.1653C11.1924 8.93722 8.93722 11.1924 6.1653 11.1924Z"
                        fill="#B0B5BF"
                      />
                      <path
                        d="M13.833 13.0283L10.5701 9.76538C10.3478 9.54305 9.98771 9.54305 9.76538 9.76538C9.54305 9.98752 9.54305 10.348 9.76538 10.5701L13.0283 13.833C13.1394 13.9441 13.2849 13.9997 13.4306 13.9997C13.5761 13.9997 13.7218 13.9441 13.833 13.833C14.0553 13.6108 14.0553 13.2504 13.833 13.0283Z"
                        fill="#B0B5BF"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_376">
                        <rect width="14" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </label>
                <input
                  onChange={(e) => {
                    setsearchItem(e.target.value);
                    if (e.target.value === "") {
                      dispatch(clearFilterBooking());
                    }
                  }}
                  value={searchItem}
                  id="search"
                  type="search"
                  className="flex-grow bg-transparent outline-none"
                  placeholder="Search..."
                  autoComplete="off"
                />
                {pathname === "/ordermanage" && (
                  <div
                    className="mr-5 my-3 cursor-pointer"
                    onClick={() => setShowModal(true)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M0.5 4.1749H8.64103C8.86559 5.08221 9.68634 5.75699 10.6621 5.75699C11.6378 5.75699 12.4585 5.08221 12.6831 4.1749H15.5C15.7761 4.1749 16 3.95102 16 3.6749C16 3.39877 15.7761 3.1749 15.5 3.1749H12.6831C12.4585 2.26759 11.6378 1.59277 10.662 1.59277C9.68628 1.59277 8.86553 2.26759 8.641 3.1749H0.5C0.223875 3.1749 0 3.39877 0 3.6749C0 3.95102 0.223875 4.1749 0.5 4.1749ZM10.6621 2.59277C11.2587 2.59277 11.7442 3.07821 11.7442 3.67487C11.7442 4.27155 11.2587 4.75699 10.6621 4.75699C10.0654 4.75699 9.57994 4.27155 9.57994 3.67487C9.57994 3.07821 10.0654 2.59277 10.6621 2.59277ZM0.5 8.49952H3.31694C3.5415 9.40684 4.36222 10.0816 5.33797 10.0816C6.31372 10.0816 7.13444 9.40684 7.359 8.49952H15.5C15.7761 8.49952 16 8.27565 16 7.99952C16 7.7234 15.7761 7.49952 15.5 7.49952H7.35897C7.13441 6.59221 6.31369 5.9174 5.33794 5.9174C4.36219 5.9174 3.54147 6.59221 3.31691 7.49952H0.5C0.223875 7.49952 0 7.7234 0 7.99952C0 8.27565 0.223844 8.49952 0.5 8.49952ZM5.33794 6.9174C5.93462 6.9174 6.42006 7.40284 6.42006 7.99952C6.42006 8.59618 5.93462 9.08162 5.33794 9.08162C4.74125 9.08162 4.25581 8.59618 4.25581 7.99952C4.25581 7.40284 4.74125 6.9174 5.33794 6.9174ZM15.5 11.8241H12.6831C12.4585 10.9168 11.6378 10.242 10.662 10.242C9.68628 10.242 8.86556 10.9168 8.641 11.8241H0.5C0.223875 11.8241 0 12.048 0 12.3241C0 12.6003 0.223875 12.8241 0.5 12.8241H8.64103C8.86559 13.7315 9.68631 14.4063 10.6621 14.4063C11.6378 14.4063 12.4585 13.7315 12.6831 12.8241H15.5C15.7761 12.8241 16 12.6003 16 12.3241C16 12.048 15.7762 11.8241 15.5 11.8241ZM10.6621 13.4063C10.0654 13.4063 9.57994 12.9208 9.57994 12.3241C9.57994 11.7275 10.0654 11.242 10.6621 11.242C11.2587 11.242 11.7442 11.7275 11.7442 12.3241C11.7442 12.9208 11.2587 13.4063 10.6621 13.4063Z"
                        fill="#B1B1B1"
                      />
                    </svg>
                  </div>
                )}
              </div>
            )}
            {pathname === "/ordermanage" && !isSearch && (
              <div
                role="tablist"
                className=" flex space-x-8 justify-center text-base mx-auto pt-6 text-[15px]"
              >
                <div
                  onClick={() => {
                    settabs({
                      tab1: true,
                      tab2: false,
                      tab3: false,
                      tab4: false,
                    });
                  }}
                >
                  <div
                    onClick={() => {
                      dispatch(
                        setSections({
                          allBooking: true,
                          upcomingBooking: false,
                          jobsForToday: false,
                          jobsForTomorrow: false,
                        })
                      );
                    }}
                    className={`transform transition-transform ${
                      tabs.tab1 ? "" : "text-base "
                    } cursor-pointer text-white`}
                  >
                    All Bookings {totalBookingCount}
                  </div>
                  <div
                    className={` transform ${
                      tabs.tab1
                        ? "translate-x-0 border-b-2 border-blue-500 shadow-blue-500 pt-1.5 "
                        : "translate-x-10"
                    } transition-transform duration-200 cursor-pointer`}
                  />
                </div>
                <div
                  onClick={() => {
                    settabs({
                      tab1: false,
                      tab2: true,
                      tab3: false,
                      tab4: false,
                    });
                  }}
                  className="relative w-max"
                >
                  <div
                    onClick={() => {
                      dispatch(
                        setSections({
                          allBooking: false,
                          upcomingBooking: true,
                          jobsForToday: false,
                          jobsForTomorrow: false,
                        })
                      );
                    }}
                    className="text-white cursor-pointer"
                  >
                    Upcoming Bookings {upcomingBookingLength}
                  </div>
                  <div
                    className={` transform ${
                      tabs.tab2
                        ? "translate-x-0 border-b-2 border-blue-500 pt-1.5"
                        : (!tabs.tab1 && !tabs.tab3) ||
                          (!tabs.tab2 && !tabs.tab1)
                        ? "translate-x-10"
                        : "-translate-x-10"
                    } transition-transform duration-200`}
                  />
                </div>
                <div
                  onClick={() => {
                    settabs({
                      tab1: false,
                      tab2: false,
                      tab3: true,
                      tab4: false,
                    });
                  }}
                  className="relative w-max"
                >
                  <div
                    onClick={() => {
                      dispatch(
                        setSections({
                          allBooking: false,
                          upcomingBooking: false,
                          jobsForToday: true,
                          jobsForTomorrow: false,
                        })
                      );
                    }}
                    className="text-white cursor-pointer"
                  >
                    Jobs for today {jobsForTodayLength}
                  </div>
                  <div
                    className={` transform ${
                      tabs.tab3
                        ? "translate-x-0 border-b-2 border-blue-500 pt-1.5"
                        : !tabs.tab1 && !tabs.tab2
                        ? "translate-x-10"
                        : "-translate-x-10"
                    } transition-transform duration-200`}
                  />
                </div>
                <div
                  onClick={() => {
                    settabs({
                      tab1: false,
                      tab2: false,
                      tab3: false,
                      tab4: true,
                    });
                  }}
                  className="relative w-max"
                >
                  <div
                    onClick={() => {
                      dispatch(
                        setSections({
                          allBooking: false,
                          upcomingBooking: false,
                          jobsForToday: false,
                          jobsForTomorrow: true,
                        })
                      );
                    }}
                    className="text-white cursor-pointer"
                  >
                    Jobs for tomorrow {jobsForTomorrowLength}
                  </div>
                  <div
                    className={` transform 
                ${
                  tabs.tab4
                    ? "translate-x-0 border-b-2 border-blue-500 pt-1.5"
                    : "-translate-x-10 "
                } 
                 transition-transform duration-200`}
                    // className={` translate-x-0 transform border-b-2 border-white
                    // transition-transform duration-200
                    // `}
                  />
                </div>
              </div>
            )}
            {pathname === "/ordermanage" && isSearch && (
              <div className="flex flex-col space-y-4 m-5">
                <div className="mt-2 flex items-center justify-center space-x-3 ">
                  <div className="text-[18px] font-semibold">
                    Search Results
                  </div>
                  <div className=" text-black px-2 text-lg bg-white rounded-full">
                    {filteredBookings?.length}
                  </div>
                </div>
              </div>
            )}
            {showModal && <FilterForm onModalOff={() => setShowModal(false)} />}
          </div>
        )}

        <div className="col-span-1"> </div>
        {/*  Above column is added for styling purposes, that's all */}

        {/* Profile and Icon */}
        <div className="col-span-2">
          <div className="flex items-center space-x-3">
            {token && (
              <div>
                <div
                  className="sm:hidden"
                  onClick={() => {
                    dispatch(setProfileBoxAction({ profileBoxAction: true }));
                  }}
                >
                  <div>
                    <HiDotsVertical className="w-10 h-6 text-white/80" />
                  </div>
                </div>
                <div className="hidden sm:flex flex-col justify-center items-end">
                  <div
                    className="w-fit h-[38px] flex items-center space-x-1.5 cursor-pointer group bg-gray-900 border-white rounded-full pl-6 pr-4 py-2"
                    onClick={() => {
                      dispatch(setProfileBoxAction({ profileBoxAction: true }));
                    }}
                  >
                    <div>
                      <h2 className="text-xs text-white/50">Welcome</h2>
                      <h2 className="text-white -mt-0.5">
                        {user?.affiliateName}
                      </h2>
                    </div>
                    <SlArrowDown className="h-8 w-8 p-2 text-white/80 font-light" />
                  </div>
                  {/* TOP PAGINATION */}
                  {pathname === "/ordermanage" && !isSearch && (
                    <div className="translate-y-2 mt-6 flex items-center sm:right-14 md:right-14 xl:right-20 2xl:right-36 top-16 sm:top-24 md:top-14 2md:top-5 space-x-3 justify-end  mb-0 md:pb-0 text-white">
                      <div className=" font-body">
                        Page: {pageCount} / {Math.ceil(totalBookingCount / 10)}
                      </div>
                      <div
                        onClick={() => {
                          pageCount > 1 && dispatch(setPagePrev());
                        }}
                        className={`flex  space-x-2 items-center ${
                          pageCount > 1 ? "cursor-pointer" : "text-gray-400"
                        }  `}
                      >
                        <FontAwesomeIcon
                          icon={faArrowAltCircleLeft}
                          className={`flex  space-x-2 items-center ${
                            pageCount > 1 ? "cursor-pointer" : "text-gray-400"
                          }  `}
                        />
                        <div className="font-body font-semibold">Prev</div>
                      </div>

                      <div
                        onClick={() => {
                          pageCount < Math.ceil(totalBookingCount / 10) &&
                            dispatch(setPageNext());
                        }}
                        className={`flex space-x-2 items-center ${
                          pageCount < Math.ceil(totalBookingCount / 10)
                            ? "cursor-pointer"
                            : " text-gray-400"
                        }  `}
                      >
                        <div className="font-body font-semibold">Next</div>
                        <FontAwesomeIcon
                          icon={faArrowAltCircleRight}
                          className={`flex space-x-2 items-center ${
                            pageCount < Math.ceil(totalBookingCount / 10)
                              ? "cursor-pointer"
                              : " text-gray-400"
                          }  `}
                        />
                      </div>
                    </div>
                  )}
                </div>
                {profileBoxAction && (
                  <div className="z-[70] w-[274px] h-auto absolute top-0 right-4 pt-4 pb-7 bg-gradient-to-b from-slate-900 to-black rounded-xl shadow border border-white/30 popbox">
                    <div className="flex justify-center">
                      <img
                        src={user?.logo?.secure_url}
                        alt=""
                        className="w-16 h-16 bg-white/60 rounded-full p-[1px]"
                      />
                    </div>
                    <h2 className="text-white font-semibold text-center my-2">
                      {user?.affiliateName}
                    </h2>
                    <div className="mx-4">
                      <h2 className="text-white text-sm py-1.5">
                        Email address
                      </h2>
                      <div className="flex items-center space-x-2 bg-white border-[#dddddd] rounded-lg px-2 py-2.5 text-center">
                        <BiEnvelope className="text-slate-600 text-2xl" />
                        <h2 className="font-normal text-base text-slate-600 truncate">
                          {user?.email1}
                        </h2>
                      </div>
                    </div>
                    <div className="mx-4 my-3">
                      <div
                        className="bg-blue-600 border border-blue-900 rounded-lg py-2 text-base text-white font-semibold cursor-pointer text-center"
                        onClick={() => {
                          setopenlogoutModal(!openlogoutModal);
                        }}
                      >
                        Log Out
                      </div>

                      {openlogoutModal && (
                        <div className="bg-black w-[270px] rounded-xl absolute bottom-0 right-0 z-10 pb-3 ">
                          <div className="px-5 py-3 text-base text-white font-medium cursor-pointer text-center">
                            Are you sure to logout?
                          </div>
                          <div className="flex justify-center space-x-7">
                            <button
                              onClick={() => {
                                setopenlogoutModal(false);
                                dispatch(
                                  setProfileBoxAction({
                                    profileBoxAction: false,
                                  })
                                );
                                // setopenprofileBox(false);
                              }}
                              className="bg-[#858597] px-5 py-1 text-white rounded-md"
                            >
                              No
                            </button>
                            <button
                              onClick={() => {
                                setopenlogoutModal(!openlogoutModal);

                                dispatch({
                                  type: "AUTH_LOGOUT",
                                  payload: { navigate, email: user?.email1 },
                                });
                              }}
                              className="bg-blue-600 px-5 py-1 rounded-md text-white"
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {pathname === "/ordermanage" && (
        <>
          {isSearch && (
            <div className="pb-4 flex items-center justify-center gap-x-2">
              {Object.keys(filterForm)?.map((item) => {
                if (filterForm[item] && item !== "dateType") {
                  let data = filterForm[item];
                  if (
                    item === "singleDate" ||
                    item === "startDate" ||
                    item === "endDate"
                  ) {
                    data = moment(filterForm[item])?.format("DD-MM-YYYY");
                  }
                  return (
                    <div className="chip-border-gradient p-[2px] rounded-full">
                      <div className="bg-black rounded-full">
                        <div className="rounded-full flex justify-center items-center h-8  px-[11.5px] py-[8PX] space-x-[7px]">
                          <div>{data}</div>
                          <div
                            className="cursor-pointer"
                            onClick={() => {
                              const newo = { ...filterForm };
                              const dispatchObj = {
                                ...newo,
                                [item]: "",
                              };
                              dispatch(setFilterForm(dispatchObj));
                              let count = 0;
                              Object.keys(newo)?.map((key) => {
                                if (newo[key] && key !== "dateType") {
                                  count++;
                                }
                              });
                              console.log(count);
                              if (count === 1 || count == 0) {
                                dispatch(clearFilterBooking());
                                return;
                              }
                              dispatch(setIsSearch({ isSearch: true }));
                              const payload = {
                                token: token,
                                affiliateId: user?._id,
                                ...dispatchObj,
                              };
                              dispatch({
                                type: "FILTER_AFFILIATE_COMPLETE",
                                payload: payload,
                              });
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="17"
                              height="16"
                              viewBox="0 0 17 16"
                              fill="none"
                            >
                              <path
                                d="M4.5 4L12.5 12"
                                stroke="#787878"
                                stroke-width="1.5"
                                stroke-linecap="round"
                              />
                              <path
                                d="M4.5 12L12.5 4"
                                stroke="#787878"
                                stroke-width="1.5"
                                stroke-linecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
              <div
                className="cursor-pointer size-8 bg-white rounded-full"
                onClick={() => {
                  dispatch(setIsSearch({ isSearch: false }));
                  dispatch(clearFilterBooking());
                }}
              >
                <svg
                  className="h-full mx-auto"
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                >
                  <g clip-path="url(#clip0_65_119)">
                    <path
                      d="M9.95781 1.63887H11.1625C11.4906 1.63887 11.7578 1.37168 11.7578 1.04355C11.7578 0.71543 11.4906 0.448242 11.1625 0.448242H8.78125C8.45313 0.448242 8.18594 0.71543 8.18594 1.04355V3.4248C8.18594 3.75293 8.45313 4.02012 8.78125 4.02012C9.10938 4.02012 9.37656 3.75293 9.37656 3.4248V2.68184C10.5039 3.58184 11.1625 4.93184 11.1625 6.40137C11.1625 9.02637 9.025 11.1639 6.4 11.1639C6.07187 11.1639 5.80469 11.4311 5.80469 11.7592C5.80469 12.0873 6.07187 12.3545 6.4 12.3545C9.68359 12.3545 12.3531 9.68496 12.3531 6.40137C12.3531 4.49824 11.4625 2.75918 9.95781 1.63887Z"
                      fill="#555555"
                    />
                    <path
                      d="M4.01914 8.78262C3.69102 8.78262 3.42383 9.0498 3.42383 9.37793V10.1209C2.29648 9.2209 1.63789 7.87324 1.63789 6.40137C1.63789 3.77637 3.77539 1.63887 6.40039 1.63887C6.72852 1.63887 6.9957 1.37168 6.9957 1.04355C6.9957 0.71543 6.72852 0.448242 6.40039 0.448242C3.1168 0.448242 0.447266 3.11777 0.447266 6.40137C0.447266 8.30684 1.33555 10.0436 2.84258 11.1639H1.63789C1.30977 11.1639 1.04258 11.4311 1.04258 11.7592C1.04258 12.0873 1.30977 12.3545 1.63789 12.3545H4.01914C4.34727 12.3545 4.61445 12.0873 4.61445 11.7592V9.37793C4.61445 9.0498 4.34727 8.78262 4.01914 8.78262Z"
                      fill="#555555"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_65_119">
                      <rect
                        width="12"
                        height="12"
                        fill="white"
                        transform="translate(0.400391 0.401367)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
          )}
          <div className="h-px bottom-0 bg-gradient-to-r from-[#111111] via-[#848484] to-[#111111]"></div>
        </>
      )}
    </div>
  );
};

export default Navbar;
